import React from "react";
import {
  Bar,
  BarChart,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";


const formatSar = (value) =>
  Number(value || 0).toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

const ChargeTooltip = ({ active, payload, label }) => {
  if (!active || !payload?.length) return null;
  const row = payload[0]?.payload || {};
  return (
    <div className="membership-timeline-tooltip">
      <strong>{label}</strong>
      <div>Total: SAR {formatSar(row.total)} · {row.charge_count || 0} charge(s)</div>
      {(row.details || []).slice(0, 8).map((detail) => (
        <div className="membership-timeline-detail" key={`${detail.user_id}-${detail.paid_on}-${detail.amount_sar}`}>
          <span>{detail.customer_name} (User {detail.user_id})</span>
          <span>{detail.plan_title} · {detail.term_label} · {detail.source_label} · SAR {formatSar(detail.amount_sar)} · {detail.paid_on}</span>
        </div>
      ))}
      {Number(row.additional_count || 0) > 0 ? (
        <div className="membership-timeline-more">+{row.additional_count} more charge(s)</div>
      ) : null}
    </div>
  );
};

const axisLabel = (label, index, count, daily) => {
  const showLabel = daily
    ? index % 5 === 0 || index === count - 1
    : index % 2 === 0 || index === count - 1;
  if (!showLabel) return "";
  return daily ? label : label.replace(/^([A-Za-z]{3}) \d{2}(\d{2})$/, "$1 '$2");
};

const MembershipChargeTimeline = ({ title, periodLabel, data = [], daily = false }) => (
  <div className="background-grpah membership-timeline-card">
    <div className="d-flex align-items-center justify-content-between w-100 pb-2">
      <h5 className="w-100 mb-0">{title}</h5>
    </div>
    <div className="membership-timeline-period">{periodLabel}</div>
    <div className="membership-timeline-chart">
      <div className="membership-timeline-canvas">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart
            data={data}
            margin={{ top: 8, right: 12, left: 12, bottom: 12 }}
            barCategoryGap="24%"
          >
            <XAxis
              dataKey="label"
              interval={0}
              tickFormatter={(label, index) => axisLabel(label, index, data.length, daily)}
              angle={0}
              textAnchor="middle"
              height={30}
              tick={{ fontSize: 11 }}
              tickMargin={8}
            />
            <YAxis
              tickFormatter={(value) => `SAR ${Number(value || 0).toLocaleString("en-US")}`}
              width={88}
            />
            <CartesianGrid strokeDasharray="3 3" />
            <Tooltip content={<ChargeTooltip />} />
            <Bar
              dataKey="total"
              name="Revenue"
              fill="#2D9D4D"
              maxBarSize={30}
              radius={[8, 8, 0, 0]}
            />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  </div>
);


export default MembershipChargeTimeline;
